// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let MatchingStatusUpdaterLocalQuery_graphql = require("../../../__generated__/MatchingStatusUpdaterLocalQuery_graphql.bs.js");

let convertVariables = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertVariables;

let convertResponse = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = MatchingStatusUpdaterLocalQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, MatchingStatusUpdaterLocalQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(MatchingStatusUpdaterLocalQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(MatchingStatusUpdaterLocalQuery_graphql.node, convertVariables);

let commitLocalPayload = RescriptRelay_Query.commitLocalPayload(MatchingStatusUpdaterLocalQuery_graphql.node, convertVariables, convertWrapRawResponse);

let LocalMatchingStatusQuery_matchingStatusV5_decode = MatchingStatusUpdaterLocalQuery_graphql.Utils.matchingStatusV5_decode;

let LocalMatchingStatusQuery_matchingStatusV5_fromString = MatchingStatusUpdaterLocalQuery_graphql.Utils.matchingStatusV5_fromString;

let LocalMatchingStatusQuery = {
  matchingStatusV5_decode: LocalMatchingStatusQuery_matchingStatusV5_decode,
  matchingStatusV5_fromString: LocalMatchingStatusQuery_matchingStatusV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain,
  commitLocalPayload: commitLocalPayload
};

function update(environment, nodeId, __typename, matchingStatus) {
  commitLocalPayload(environment, {
    nodeId: nodeId
  }, {
    node: {
      __typename: __typename,
      __isMatchable: __typename,
      matchingStatus: matchingStatus,
      nodeId: nodeId
    }
  });
}

exports.LocalMatchingStatusQuery = LocalMatchingStatusQuery;
exports.update = update;
/* use Not a pure module */
